<template>
  <div class="container">
    <img src="/assets/images/logo.png" />
    <div class="connectionForm form">
      <div class="label">
        <label>Identifiant : </label>
      </div>
      <div class="value">
        <input v-model="login" type="text" tabindex="1" />
      </div>

      <div class="label">
        <label>Mot de passe : </label>
      </div>
      <div class="value">
        <input id="ti_connect_password" v-model="password" type="password" tabindex="2" />
      </div>

      <div class="value">
        <a @click.prevent="connectClicked" class="bouton" tabindex="3">
          Connexion
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { idyuConnect, idyuRetrieveSession, idyuCryptPassword } from "@/assets/js/idyu/connect.js";
import { idyuInit } from "@/assets/js/idyu/init.js";

export default {
  name: "ConnectionForm",
  data() {
    return {
      loading: false,
      login: "",
      password: ""
    };
  },

  methods: {
    connectClicked: async function() {
      try {
        this.loading = true;
        const crypt = idyuCryptPassword(this.login, this.password);
        const res = await idyuConnect(this.login, crypt);
        if (res !== 0) await alert("Identifiant ou mot de passe incorrect.");
        else {
          this.$global.pageInitiated = idyuRetrieveSession(this);
          const res = await this.$global.pageInitiated;
          if (res) {
            idyuInit(this.$store, res, this.$router);
            this.$router.push({ name: "Profil" });
          } else throw new Error(); // should never happen
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error.message);
        await alert("Erreur de connexion : " + error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";
@import "@/assets/css/forms.scss";

.container {
  display: grid;
  align-content: center;
  justify-items: center;
  align-items: center;
  grid-template-rows: min-content min-content;
  grid-gap: 20px;
}

@media screen and (max-width: 310px) {
  .formItem {
    grid-template-columns: auto;
    text-align: left;
    grid-gap: 0;
  }
}
</style>
